import Button from './Button';
import Card from './Card';

import './ConfirmationWarning.scss';

const ConfirmationWarning = ({
	title,
	subtitle,
	message,
	acceptLabel,
	declineLabel,
	onAccept,
	onDecline
}) => {
	return (
		<>
			<section>
				<header>
					<h2>{title}</h2>
				</header>
			</section>
			<div className='confirmation-Warning-subtitle'>
				<p>{subtitle}</p>
			</div>
			<div>
				<p>{message}</p>
			</div>
			<footer className='confirmation-Warning-controllers'>
				<Button
					className='primary-button'
					onClick={onAccept}
				>
					{acceptLabel}
				</Button>
				<Button
					className='secondary-button'
					onClick={onDecline}
				>
					{declineLabel}
				</Button>
			</footer>
		</>
	);
};

export default ConfirmationWarning;
